import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/qualifications")({
  component: QualificationsLayout,
});

function QualificationsLayout() {
  return <Outlet />;
}
